import baseStore from '../generic_store'
import Axios from "axios";
import store from "../index";

const base = baseStore('videos');

const state = {
    ...base.state,
    base_url: '/api/videos',
    resourceName: 'Video',
    model: {},
};

const getters = {
    ...base.getters,
};

const mutations = {
    ...base.mutations,
};

const actions = {
    ...base.actions,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
